import  React from 'react';
import  Spinner from '../Spinner';
import P from 'prop-types';
function SuspenseUntil({shouldSuspense, SuspenseComponent , children, ...props}){
  if(shouldSuspense){
    return <SuspenseComponent/>
  }

  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, {...props})
  );

  return childrenWithProps
}


  SuspenseUntil.propTypespropTypes = {
    shouldSuspense: P.bool,
    SuspenseComponent: P.oneOfType([P.string, P.func]),
  };

  SuspenseUntil.defaultProps = {
    SuspenseComponent: Spinner,
  };

  export default SuspenseUntil;



// WEBPACK FOOTER //
// ./src/components/SuspenseUntil/SuspenseUntil.js